import { BetsCycleLoader } from '@/components/ui/betscycle-loader'
import { useSportsbookRenderer } from '@/hooks/use-sportsbook-renderer'
import { cn } from '@/lib/utils'

interface SportsbookViewerProps {
	url: string | null
	sportsbookName?: string
	token: string | null
	sessionId: string | null
	isLaunching?: boolean
	className?: string
}

export function SportsbookViewer({ url, sportsbookName, token, sessionId, isLaunching = false, className }: SportsbookViewerProps) {
	const ready = Boolean(token && sessionId)
	const { containerRef, scriptLoaded } = useSportsbookRenderer({
		token,
		sessionId,
		enabled: ready && !isLaunching,
	})

	const isBusy = isLaunching || (ready && !scriptLoaded)

	return (
		<div className={cn('relative flex min-h-0 w-full flex-1 overflow-hidden bg-card', className)}>
			{isBusy ? (
				<div className='absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-card'>
					<BetsCycleLoader size={40} />
					<p className='text-sm font-medium text-muted-foreground'>Loading sportsbook...</p>
				</div>
			) : null}

			{!ready && !isBusy ? (
				<div className='absolute inset-0 flex items-center justify-center p-6'>
					<p className='text-sm text-muted-foreground'>Select a sportsbook to get started.</p>
				</div>
			) : null}

			{/* <iframe
				key={url}
				src={url}
				title={sportsbookName ?? 'Sportsbook'}
				className='absolute inset-0 h-full w-full border-0'
				allow='autoplay; fullscreen; encrypted-media'
				allowFullScreen
			/> */}
			<div id='bettech' ref={containerRef} className='min-h-[700px] w-full flex-1 [&_iframe]:border-0' />
		</div>
	)
}
